export const AUTH_PAGE_CONTENT_CLASS_NAME =
  'flex h-[100dvh] items-start justify-center pt-[clamp(72px,10vh,128px)] max-md:pt-10';
